import React, { ReactNode } from "react";
import "./ProductList.scss";
import ProductItem from "@components/ProductItem/ProductItem";
import { Empty, Skeleton } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import { useUser } from "contexts/UserContext";

interface IProductList {
  isOpenMap?: boolean;
  products: any;
  type: string;
  additional?: ReactNode;
  isLargeMode?: boolean;
  setIsLargeMode?: (mode: boolean) => void;
  selectedProductId?: null | number;
  selectedProduct?: number[];
  setSelectedProduct?: (value: number[]) => void;
  setSelectedProductId?: (value: null | number) => void;
}

const ProductList: React.FC<IProductList> = ({
  products,
  isOpenMap,
  type,
  isLargeMode = false,
  additional,
  selectedProductId,
  setSelectedProductId,
  selectedProduct,
  setSelectedProduct,
}) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { userProfile } = useUser();

  return (
    <div className="ProductList">
      {!selectedProductId && type !== "My Products" && (
        <div
          className={`section-title${
            type === "Promoted Products ⚡" ? " promoted" : ""
          }`}
        >
          {type}
          {additional && <div className="additional">{additional}</div>}
        </div>
      )}
      {products == null ? (
        <div
          className={`product-group ${
            isOpenMap
              ? "product-group-3"
              : type === "My Products"
              ? "product-group-4"
              : "product-group-5"
          }`}
        >
          {Array.from({
            length: type === "Product List" ? 10 : type === "Results" ? 30 : 5,
          }).map((_, index) => {
            return (
              <div className="product-item" key={index}>
                <div className="product-placeholder">
                  <Skeleton.Image active={true} className="skeleton-image" />
                  <div className="content">
                    <Skeleton active={true} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : products.length === 0 ? (
        <div className="product-group product-group-5">
          <div className="product-item">
            <div
              className="product-register-btn"
              onClick={() =>
                navigate(
                  window.location.pathname.includes("all")
                    ? window.location.pathname.replace("all", "register")
                    : "/product/register"
                )
              }
            >
              <div className="title">Register Product</div>
              <div className="icon">
                <PlusOutlined />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`product-group ${
            selectedProductId
              ? "product-group-1"
              : isOpenMap
              ? isLargeMode
                ? "product-group-2"
                : "product-group-3"
              : isLargeMode
              ? "product-group-3"
              : type === "My Products"
              ? "product-group-4"
              : "product-group-5"
          }`}
        >
          {products.map((item: any, index: number) => {
            if (type == "Other Products" && index > 4) return;
            return (
              <div className="product-item" key={index}>
                <ProductItem
                  key={`${item.product_id}-${index}`}
                  data={item}
                  isAuction={type === "Current Auction" ? true : false}
                  type={type}
                  index={index}
                  setSelectedProductId={setSelectedProductId}
                  selectedProduct={selectedProduct}
                  setSelectedProduct={setSelectedProduct}
                />
              </div>
            );
          })}
          {/* {type === "Promoted Products ⚡" && isAuthenticated && (
            <div className="product-item">
              <Link
                to="/profile?direct=ads-register"
                className="product-register-btn"
              >
                <div className="title">Register Ads</div>
                <div className="icon">
                  <PlusOutlined />
                </div>
              </Link>
            </div>
          )} */}
        </div>
      )}
    </div>
  );
};

export default ProductList;
